import { useBrand } from '@hbo/ui-servicing-react-components';
import { useQuery } from '@tanstack/react-query';
import { CaseTrackingService } from 'services/case';
import { SubmittedCase } from 'types/case';

interface UseCaseHook {
  data: SubmittedCase | undefined;
  isLoading: boolean;
  isError: boolean;
  error: any;
  isSuccess: boolean;
}

export const useCase = (): UseCaseHook => {
  const { brand } = useBrand();
  return useQuery({
    queryKey: [brand],
    queryFn: () => CaseTrackingService.getCaseByMortgageReferenceByToken()
  });
};
